import { render, staticRenderFns } from "./PackagesItem.vue?vue&type=template&id=10263a12&scoped=true&"
import script from "./PackagesItem.vue?vue&type=script&lang=js&"
export * from "./PackagesItem.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PackagesItem.vue?vue&type=style&index=0&id=10263a12&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "10263a12",
  "50599b0f"
  
)

export default component.exports